export const INPUT_ERROR = 'isErrored';
export const INPUT_FILLED = 'isFilled';
export const INPUT_FOCUSED = 'isFocused';
